<template>
  <div class="profile-layout type-profile">
    <main-navbar></main-navbar>
    <div class="wrapper" :class="[{ 'nav-open': $sidebar.showSidebar }]">
      <notifications></notifications>
      <side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <!-- <mobile-menu :app="true"></mobile-menu> -->
        <template slot="links">
          <div class="profiles">
            <sidebar-item
              v-if="!isAcademic"
              class="sidebar-item-plus"
              :link="{
                name: 'Prospect Search',
                icon: 'source',
                path: '/prospect-search',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Financial',
                icon: 'card_travel',
                path: '/new-profile/industry-financial-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Industry Market',
                icon: 'leaderboard',
                path: '/new-profile/industry-market-profile',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Companies',
                icon: 'business',
                path: '/company-search',
              }"
            ></sidebar-item>
            <div class="disable">
              <sidebar-item
                v-if="!isAcademic"
                :link="{
                  name: 'Market',
                  icon: 'insights',
                  path: '/',
                }"
              ></sidebar-item>
              <sidebar-item
                v-if="!isAcademic"
                :link="{
                  name: 'Franchise',
                  icon: 'store',
                  path: '/',
                }"
              ></sidebar-item>
            </div>
            <!--<sidebar-item
              :link="{
                name: 'Valuation Multiples',
                icon: 'addchart',
                path: '/valuation-multiple',
              }"
            ></sidebar-item>-->
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Financial Report',
                icon: 'text_snippet',
                path: '/create-report-format/financial',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Market Report',
                icon: 'newspaper',
                path: '/create-report-format/market',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Valuation Report',
                icon: 'request_quote',
                path: '/create-report-format/valuation',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Company Report',
                icon: 'summarize',
                path: '/create-report-format/company',
              }"
            ></sidebar-item>
          </div>
          <div class="section_wpr" v-if="!isAcademic">My Data</div>
          <div class="profiles border-0">
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Prospect List',
                icon: 'format_list_bulleted',
                path: '/my-prospect-lists',
              }"
            ></sidebar-item>
            <sidebar-item
              :link="{
                name: 'Profiles',
                icon: 'folder_open',
                path: '/my-profiles',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Reports',
                icon: 'description',
                path: '/my-reports',
              }"
            ></sidebar-item>
            <sidebar-item
              v-if="!isAcademic"
              :link="{
                name: 'Data',
                icon: 'dns',
                path: '/my-data',
              }"
            ></sidebar-item>
          </div>
        </template>
      </side-bar>
      <app-side-bar
        :mini="true"
        :active-color="sidebarBackground"
        :background-image="sidebarBackgroundImage"
        :data-background-color="sidebarBackgroundColor"
      >
        <mobile-menu></mobile-menu>
        <template slot="links" v-if="!spif">
          <sidebar-item
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: '/if/' + this.id + '/about',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Information',
              icon: 'chat_bubble',
              path: '/if/' + this.id + '/introduction',
              type: 'product',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'financial-fundamentals' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Financials',
                icon: 'analytics',
                path: '/if/' + this.id + '/financial-fundamentals',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <!-- <div v-if="!spif" v-popover.right="{ name: 'balance-sheet' }">
            <sidebar-item
              :class="!loading? '' : 'disabled-item'"
              :link="{
                name: 'Balance Sheet',
                icon: 'table_chart',
                path: '/if/' + this.id + '/balance-sheet',
              }"
            ></sidebar-item>
          </div>-->
          <div v-popover.right="{ name: 'ratios' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Ratios',
                icon: 'scatter_plot',
                path: '/if/' + this.id + '/ratios',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <!-- <sidebar-item
            :class="!loading? '' : 'disabled-item'"
            :link="{
              name: 'Sources Uses',
              icon: 'collections_bookmark',
              path: '/if/' + this.id + '/sources-users',
            }"
          ></sidebar-item>-->
          <sidebar-item
            :class="
              loading || this.isRetail ? 'non-subscriber disabled-item' : ''
            "
            :link="{
              name: 'Valuation Multiples',
              icon: 'query_stats',
              path: !this.isRetail
                ? '/if/' + this.id + '/valuation-multiples'
                : this.currentPath,
              type: this.isRetail ? 'disabled' : 'product',
            }"
          ></sidebar-item>
        </template>
        <template slot="links" v-if="spif">
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'About the Data',
              icon: 'help',
              path: '/spif/' + this.id + '/about',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Information',
              icon: 'chat_bubble',
              path: '/spif/' + this.id + '/introduction',
              type: 'product',
            }"
          ></sidebar-item>
          <div v-popover.right="{ name: 'profit-and-loss' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Profit & Loss',
                icon: 'analytics',
                path: '/spif/' + this.id + '/profit-and-loss',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <div v-popover.right="{ name: 'ratios' }">
            <sidebar-item
              :class="!loading ? '' : 'disabled-item'"
              :link="{
                name: 'Ratios',
                icon: 'scatter_plot',
                path: '/spif/' + this.id + '/ratios',
                type: 'product',
              }"
            ></sidebar-item>
          </div>
          <sidebar-item
            :class="!loading ? '' : 'disabled-item'"
            :link="{
              name: 'Cash Tables',
              icon: 'collections_bookmark',
              path: '/spif/' + this.id + '/cash-tables',
              type: 'product',
            }"
          ></sidebar-item>
          <sidebar-item
            :class="
              loading || this.isRetail ? 'non-subscriber disabled-item' : ''
            "
            :link="{
              name: 'Valuation Multiples',
              icon: 'query_stats',
              path: !this.isRetail
                ? '/spif/' + this.id + '/valuation-multiples'
                : this.currentPath,
              type: this.isRetail ? 'disabled' : 'product',
            }"
          ></sidebar-item>
        </template>
      </app-side-bar>
      <div class="main-panel">
        <div :class="{ content: !$route.meta.hideContent }">
          <div v-if="!isAboutRoute" class="content">
            <PulseLoader
              :loading="loading"
              :class="{ hide: !loading }"
              quote="Action is the foundational key to all success"
              author="Pablo Picasso"
              profession="Spanish Painter"
              img="picasso.jpg"
            ></PulseLoader>
          </div>
          <zoom-center-transition :duration="200" mode="out-in">
            <div class="row">
              <!-- Graceful state when the requested industry + area + sales-class
                   segment has no data in the release (soft "insufficient data"
                   response from the API) instead of rendering data-less tabs. -->
              <div
                v-if="insufficientData && !loading"
                class="insufficient-data-panel md-layout-item"
              >
                <h2>No data available for this segment</h2>
                <p>
                  This release doesn't have industry financial data for the
                  selected NAICS, geography and sales-class combination, so this
                  report can't be generated. Try a broader sales class or a
                  parent industry.
                </p>
              </div>
              <!-- your content here -->
              <router-view
                v-if="(!loading || isAboutRoute) && !insufficientData"
                :headerData="headerData"
              />
              <!--<PulseLoader :loading="loading" :class="{ hide: !loading }" class="pulse"></PulseLoader>-->
            </div>
          </zoom-center-transition>
        </div>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
    document.getElementsByClassName(className)[0].scrollTop = 0;
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

function reinitScrollbar() {
  let docClasses = document.body.classList;
  let isWindows = navigator.platform.startsWith("Win");
  if (isWindows) {
    // if we are on windows OS we activate the perfectScrollbar function
    initScrollbar("sidebar");
    initScrollbar("sidebar-wrapper");
    initScrollbar("main-panel");

    docClasses.add("perfect-scrollbar-on");
  } else {
    docClasses.add("perfect-scrollbar-off");
  }
}

function initSidebar() {
  document.body.classList.toggle("sidebar-mini");
}

import MainNavbar from "./MainNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import MobileMenu from "./Extra/MobileMenu.vue";
// import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { PulseLoader } from "@/components";
import Vuex, { mapActions } from "vuex";
import axios from "axios";

export default {
  name: "profile-layout",
  components: {
    MainNavbar,
    ContentFooter,
    MobileMenu,
    PulseLoader,
  },
  data() {
    return {
      sidebarBackgroundColor: "grey",
      sidebarBackground: "green",
      sidebarBackgroundImage:
        process.env.VUE_APP_BASE_URL + "/img/sidebar-2.jpg",
      sidebarMini: true,
      sidebarImg: true,
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
      roles: [],
      loading: true,
      isAboutRoute: false,
      headerData: [],
    };
  },
  methods: {
    ...mapActions({
      getProfile: "user/getProfile",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    init() {
      this.loading = true;
      this.getProfile({
        profile_id: this.$route.params.id,
      })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          if (res && res.errorCode === "if_insufficient_data") {
            this.alertError(
              "No industry data is available for this NAICS, area and sales-class combination."
            );
          } else if (res) {
            this.alertSuccess("Data loaded.");
          } else {
            this.alertError("An error occurred. We have been notified.");
          }
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({ isFinishedDate: true, productId: this.id });
        });
    },
    checkRoute() {
      // || this.$route.name === 'SPIFAbout'
      if (this.$route.name === "IFAbout" || this.$route.name === "SPIFAbout")
        return true;

      return false;
    },
    getHeaderData() {
      axios
        .get(process.env.VUE_APP_API_BASE_URL + "/info/productHeader", {
          params: {
            product_id: this.$route.params.id,
            session_id: localStorage.getItem("vue-authenticate.vueauth_access_token"),
          },
        })
        .then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/IMR_available" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.headerData = res.data;
        });
    },
  },
  updated() {
    // reinitScrollbar();
  },
  mounted() {
    // reinitScrollbar();
    // initSidebar();
    this.getHeaderData();
    this.isAboutRoute = this.checkRoute();
    this.init();
  },
  computed: {
    ...Vuex.mapState({
      spif: (state) => state.user.profile.spif,
      me: (state) => state.profile.me,
      isRetail: (state) =>
        state.user.user_type.retail/* || state.user.allow_retail*/ ? true : null,
      isAcademic: (state) => state.user.user_type.academic ?? null,
    }),
    id() {
      return this.$route.params.id;
    },
    currentPath() {
      return this.$route.path;
    },
    // True when the API returned the soft "insufficient data" response for this
    // segment (no rows in the release for the NAICS/area/sales-class). Used to
    // show a graceful panel instead of rendering data-less report tabs.
    insufficientData() {
      const p = this.$store.state.user.profile;
      return !!(p && p.errorCode === "if_insufficient_data");
    },
  },
  watch: {
    me: {
      handler: function(val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
    // sidebarMini() {
    //   this.minimizeSidebar();
    // },
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;

.insufficient-data-panel {
  width: 100%;
  padding: 48px 32px;
  text-align: center;
  color: #4a5568;

  h2 {
    margin-bottom: 12px;
    font-weight: 600;
  }

  p {
    max-width: 560px;
    margin: 0 auto;
  }
}

@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }

  to {
    opacity: 1;
  }
}

.main-panel .zoomIn {
  animation-name: zoomIn95;
}

@keyframes zoomOut95 {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}

.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>
